export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20abstract%20composition%20with%20soft%20golden%20amber%20and%20deep%20crimson%20red%20tones%2C%20subtle%20film%20grain%20texture%2C%20elegant%20geometric%20curtain%20shapes%20framing%20the%20edges%2C%20sophisticated%20cinema%20atmosphere%20with%20glowing%20warm%20light%20particles%2C%20dramatic%20spotlight%20effects%20on%20dark%20backdrop%2C%20high-end%20entertainment%20aesthetic%2C%20editorial%20photography%20quality%20with%20rich%20shadows%20and%20highlights%2C%20luxurious%20vintage%20movie%20theater%20ambiance%20with%20velvet%20texture%20hints&width=1600&height=900&seq=hero-bg-cinema-01&orientation=landscape"
          alt="8090影院 - 高清追剧平台主视觉"
          className="w-full h-full object-cover object-center"
          onError={(e) => {
            const el = e.currentTarget;
            el.style.display = 'none';
          }}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16 py-16 md:py-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white/90 text-xs md:text-sm font-medium mb-5">
              <i className="ri-fire-line text-accent-500"></i>
              <span>追剧不等待</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight tracking-tight">
              8090影院 — 最新电视剧全集
              <br className="hidden sm:block" />
              高清免费追剧平台
            </h1>

            <p className="mt-3 text-white/70 text-sm md:text-base font-medium tracking-wide">
              影院画质 · 同步更新 · 在线不缓冲
            </p>

            <p className="mt-6 text-white/80 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              8090影院致力于为追剧爱好者提供最新电视剧全集高清免费在线观看服务。
              我们以影院级画质呈现每一部作品，同步更新各大平台热门剧集，
              采用智能加速技术确保在线播放流畅不缓冲，让您随时随地畅享沉浸式追剧体验。
              无论是最新上线的大热剧集还是经典全集，这里都是您的首选追剧平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-500 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-white font-bold text-sm">每日更新 50+</div>
                  <div className="text-white/50 text-xs">热门剧集同步上线</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-movie-2-line text-accent-500 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-white font-bold text-sm">10000+ 剧集</div>
                  <div className="text-white/50 text-xs">海量电视剧全集覆盖</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-shield-check-line text-accent-500 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-white font-bold text-sm">稳定流畅</div>
                  <div className="text-white/50 text-xs">智能加速不缓冲</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#about"
                onClick={(e) => handleClick(e, '#about')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium text-sm rounded-lg border border-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20poster%20composition%20with%20warm%20golden%20light%20rays%20radiating%20from%20center%2C%20abstract%20film%20strip%20elements%20curving%20elegantly%2C%20soft%20glowing%20orbs%20suggesting%20movie%20screens%2C%20rich%20crimson%20and%20deep%20amber%20gradient%20atmosphere%2C%20luxurious%20velvet%20texture%20hints%2C%20premium%20entertainment%20brand%20aesthetic%2C%20clean%20elegant%20design%20with%20dramatic%20lighting%2C%20sophisticated%20and%20modern%20cinema%20visual%20identity&width=800&height=1000&seq=hero-visual-poster-01&orientation=portrait"
                  alt="8090影院 - 影院级追剧体验"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.parentElement!.style.display = 'none';
                  }}
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500/90 backdrop-blur-sm flex items-center justify-center">
                <div className="text-center text-white">
                  <div className="text-lg md:text-xl font-black leading-none">4K</div>
                  <div className="text-[10px] md:text-xs mt-0.5 opacity-80">影院画质</div>
                </div>
              </div>
              <div className="absolute -top-3 -left-3 px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-white/20">
                <span className="text-white/90 text-xs font-medium">每日更新</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}